// Lets code outside React (e.g. axios interceptors) trigger SPA navigation.
// A NavigationSetter component registers the router's navigate function here on mount.
let navigator = null;

export function setNavigator(navigateFn) {
  navigator = navigateFn;
}

export function navigateTo(path, options) {
  if (navigator) {
    navigator(path, options);
  } else {
    window.location.assign(path);
  }
}
